<template>
  <div class="row g-4">
    <div class="col-12">
      <h2 class="h4 mb-2">Welche Eigenschaften passen zu Ihrem Objekt?</h2>
      <p class="text-secondary mb-0">
        Wählen Sie die Merkmale aus, die Ihre Kernkompetenzen am besten beschreiben. Mehrfachauswahl ist möglich.
      </p>
    </div>

    <div class="col-12 col-xl-8">
      <div class="row g-3">
        <div class="col-12 col-lg-6">
          <div class="border p-3 h-100 bg-light">
            <div class="small text-uppercase fw-semibold text-secondary mb-3">Urlaubsart</div>
            <div class="vstack gap-3">
              <div v-for="checkbox in primaryCheckboxes" :key="checkbox.key" class="form-check mb-0">
                <Field type="checkbox" :name="checkbox.key">
                  <input
                    :id="checkbox.key"
                    v-model="surveyStore.data.urlaubsarten"
                    :value="checkbox.key"
                    class="form-check-input"
                    type="checkbox"
                  />
                  <label class="form-check-label" :for="checkbox.key">
                    {{ checkbox.label }}
                  </label>
                </Field>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-6">
          <div class="border p-3 h-100">
            <div class="small text-uppercase fw-semibold text-secondary mb-3">Ausstattung und Eignung</div>
            <div class="vstack gap-3">
              <div v-for="checkbox in secondaryCheckboxes" :key="checkbox.key" class="form-check mb-0">
                <Field type="checkbox" :name="checkbox.key">
                  <input
                    :id="checkbox.key"
                    v-model="surveyStore.data.urlaubsarten"
                    :value="checkbox.key"
                    class="form-check-input"
                    type="checkbox"
                  />
                  <label class="form-check-label" :for="checkbox.key">
                    {{ checkbox.label }}
                  </label>
                </Field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-xl-4">
      <div class="alert alert-primary border-0 mb-3">
        <div class="d-flex gap-3">
          <Icon icon="fa-pro-solid:lightbulb" class="mt-1 flex-shrink-0"/>
          <div>
            <div class="fw-semibold mb-2">Tipp</div>
            <p class="mb-2">Konzentrieren Sie sich auf die Merkmale, für die Ihr Objekt besonders relevant ist.</p>
            <p class="mb-0">Sie können diese Auswahl später jederzeit in der Objektbearbeitung anpassen.</p>
          </div>
        </div>
      </div>

      <div class="border p-3 bg-light">
        <div class="small text-uppercase fw-semibold text-secondary mb-2">Wichtig</div>
        <p class="mb-0 text-secondary">
          Bitte markieren Sie nur Ihre Kernkompetenzen, damit wir Ihr Objekt eindeutig zuordnen können.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {useSurveyStore} from "../../../stores/survey";
import {Field} from 'vee-validate';

export default {
  components: {
    Field,
  },
  setup() {
    return {
      surveyStore: useSurveyStore(),
    }
  },
  data() {
    return {
      checkboxes: [
        {
          key: 'landurlaub',
          label: 'Landurlaub',
          group: 'primary',
        },
        {
          key: 'schlosshotels',
          label: 'Urlaub im Schloss/Burg',
          group: 'primary',
        },
        {
          key: 'reiterhoefe',
          label: 'Reiturlaub',
          group: 'primary',
        },
        {
          key: 'bauernhoefe',
          label: 'Bauernhof',
          group: 'primary',
        },
        {
          key: 'sporthotels',
          label: 'Sporthotel',
          group: 'primary',
        },
        // {
        //   key: 'golfurlaub',
        //   label: 'Golfurlaub'
        // },
        // {
        //   key: 'angelurlaub',
        //   label: 'Angelurlaub'
        // },
        {
          key: 'sportfreizeit',
          // label: 'Aktiv-Sport-Urlaub'
          label: 'Freizeit- & Sportmöglichkeiten',
          group: 'primary',
        },
        // {
        //   key: 'alleinlage_ruheurlaub',
        //   label: 'Alleinlage-Ruheurlaub'
        // },
        // {
        //   key: 'partyurlaub',
        //   label: 'Partyurlaub'
        // },
        {
          key: 'gutshoefe',
          label: 'Urlaub im Gutshaus / auf dem Gutshof',
          group: 'primary',
        },
        {
          key: 'familienfreundlich',
          label: 'Familienfreundlich',
          group: 'secondary',
        },
        {
          key: 'wellnessbereich',
          label: 'Wellnessbereich',
          group: 'secondary',
        },
        {
          key: 'barrierefrei',
          label: 'Barrierefrei',
          group: 'secondary',
        },
        {
          key: 'hundeerlaubt',
          label: 'Hunde erlaubt',
          group: 'secondary',
        },
        // {
        //   key: 'paare',
        //   label: 'für Paare/Freunde'
        // },
        {
          key: 'natururlaub',
          label: 'Natururlaub',
          group: 'secondary',
        },
        // {
        //   key: 'schul_jugendsteatte',
        //   label: 'Schul- & Jugendstätte'
        // },
        {
          key: 'gruppen',
          label: 'Für Gruppen geeignet',
          group: 'secondary',
        },
        // {
        //   key: 'seniorengerecht',
        //   label: 'Seniorengerecht'
        // },
        {
          key: 'restaurant',
          label: 'Mit Restaurant',
          group: 'secondary',
        },
        {
          key: 'tagungsraum',
          label: 'Tagungsraum',
          group: 'secondary',
        },
        // {
        //   key: 'geschaeftsreise_ohne_tagungsraum',
        //   label: 'Geschäftsreise ohne Tagungsraum'
        // },
      ]
    }
  },
  props: {
    errors: Object,
  },
  methods: {},
  computed: {
    primaryCheckboxes() {
      return this.checkboxes.filter(checkbox => checkbox.group === 'primary')
    },
    secondaryCheckboxes() {
      return this.checkboxes.filter(checkbox => checkbox.group === 'secondary')
    }
  },

}
</script>
